<template>
    <form class="boxForm_step3" @submit.prevent="onSubmit">
      <div class="inputList">
        <BaseInput
          :placeholder="$t('qic_user_name_first')"
          :validation="$v.firstName"
          :value="firstName"
          inputStyle="big"
          ref="firstName"
          @input="onInput('firstName', $event)"
          @blur="$emit('blurFirstName', firstName)"
        />
        <BaseInput
          :placeholder="$t('qic_user_name_family')"
          :validation="$v.lastName"
          :value="lastName"
          inputStyle="big"
          ref="lastName"
          @input="onInput('lastName', $event)"
          @blur="$emit('blurLastName', lastName)"
        />
      </div>
      <BaseButton/>
      <Reminder/>
    </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'UserNameForm',
  emits: ['error', 'input', 'onSubmit', 'blurFirstName', 'blurLastName'],
  props: ['value'],
  computed: {
    firstName () {
      return this.value.firstName
    },
    lastName () {
      return this.value.lastName
    },
    submitDisabled () {
      return this.$v.$invalid
    }
  },
  methods: {
    onSubmit () {
      if (!this.validate()) return

      const regexp = /^[\s-_']*((.*[^\s-_'])?)[\s-_']*$/
      const firstName = this.firstName.replace(regexp, '$1')
      const lastName = this.lastName.replace(regexp, '$1')

      this.$emit('input', { firstName, lastName })
      this.$emit('onSubmit')
    },
    onInput (name, value) {
      const regexp = /^([a-zA-Z-\s']|[\u0621-\u064a])*$/
      const names = { ...this.value }
      names[name] = regexp.test(value) ? value : names[name]
      this.$emit('input', names)
    },
    validate () {
      this.$v.$touch()
      if (this.submitDisabled) {
        const firstName = this.$refs.firstName
        const lastName = this.$refs.lastName
        const errors = {}
        if (this.$v.firstName.$error) {
          const message = this.getErrorMessage(firstName)
          errors.firstName = message
        }
        if (this.$v.lastName.$error) {
          const message = this.getErrorMessage(lastName)
          errors.lastName = message
        }
        this.$emit('error', errors)
      }
      return !this.submitDisabled
    },
    getErrorMessage (inputComponent) {
      return inputComponent.value
        ? inputComponent.invalidErrorMessage
        : inputComponent.requireErrorMessage
    }
  },
  validations: {
    firstName: {
      required,
      validFormat: val => !/^[\s-_]+$/.test(val)
    },
    lastName: {
      required,
      validFormat: val => !/^[\s-_]+$/.test(val)
    }
  }
}
</script>
